import React from 'react';
import { Routes, Route} from 'react-router-dom';
import TopNotice from './Components/TopNotice.js';
import Navbar from './Components/Navbar.js';
import Carousel from './Components/Carousel.js';
import Feature from './Components/Feature.js';
import AboutUs from './Components/AboutUs.js';
import Counts from './Components/Counts.js';
import Services from './Components/Services.js';
import Hospital from './Components/Hospital.js';
import Health from './Components/Health.js';
import School from './Components/School.js';
import Tannery from './Components/Tannery.js';
import Terms from './Components/TermsAndConditions.js';
import PrivacyPolicy from './Components/PrivacyPolicy.js';
import CancellationRefundPolicy from './Components/CancellationRefundPolicy.js';
import Client from './Components/Client.js';
import Contact from './Components/Contact.js';
import Footer from './Components/Footer.js';
import ZainSafety from './Components/ZainSafety.js';
import './App.css';
import './CSS/Mobile.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={
        <>              
          <TopNotice />
          <Navbar />
          <Carousel />
          <Feature />
          <AboutUs />
          <Counts />
          <Services />
          <Client />
          <Contact />
          <Footer />
        </>
      } />
      <Route path="/Hospital" element={
        <>              
          <TopNotice />
          <Navbar />
          <Carousel />
          <Hospital />
          <Client />
          <Contact />
          <Footer />
        </>
      } />
      <Route path="/Health" element={
        <>              
          <TopNotice />
          <Navbar />
          <Carousel />
          <Health />
          <Client />
          <Contact />
          <Footer />
        </>
      } />
      <Route path="/School" element={
        <>              
          <TopNotice />
          <Navbar />
          <Carousel />
          <School />
          <Client />
          <Contact />
          <Footer />
        </>
      } />
      <Route path="/Tannery" element={
        <>              
          <TopNotice />
          <Navbar />
          <Carousel />
          <Tannery />
          <Client />
          <Contact />
          <Footer />
        </>
      } />
      <Route path="/Terms" element={
        <>              
          <TopNotice />
          <Navbar />
          <Terms /> 
          <Footer />
        </>
      } />
      <Route path="/PrivacyPolicy" element={
        <>              
          <TopNotice />
          <Navbar />
          <PrivacyPolicy /> 
          <Footer />
        </>
      } />
      <Route path="/CancellationRefundPolicy" element={
        <>              
          <TopNotice />
          <Navbar />
          <CancellationRefundPolicy /> 
          <Footer />
        </>
      } />
      <Route path="/ZainSafety" element={
        <>              
          <TopNotice />
          <Navbar />
          <ZainSafety /> 
          <Footer />
        </>
      } />
    </Routes>
  );
}

export default App;
